import { APIClient } from "./api_helper";
import * as url from "./url_helper";

const api = new APIClient();

// Team management API functions
const teamApi = {
  // Get all team users for the company
  getTeamUsers: () => api.get("/user/team"),

  // Add a new team user
  addTeamUser: (userData: {
    fullName: string;
    email: string;
    password: string;
  }) => api.create("/user/team", userData),

  // Update a team user
  updateTeamUser: (userId: number, userData: {
    fullName: string;
    email: string;
    password: string;
  }) => api.put(`/user/team/${userId}`, userData),

  // Update team user status
  updateTeamUserStatus: (userId: number, status: number) =>
    api.put(`/user/team/${userId}/status`, { status }),

  getTeamData: () => api.get(url.GET_TEAMDATA),
  addTeamData: (team: any) => api.create(url.ADD_NEW_TEAMDATA, team),
  updateTeamData: (team: any) => api.put(url.UPDATE_TEAMDATA, team),
  deleteTeamData: (team: any) => api.delete(url.DELETE_TEAMDATA, { headers: { team } })
};

export { teamApi };